import * as React from 'react';
import { ArticleHeading3, ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './promoIntro.css';

export interface IPromoItemProps {
  dueDate?: string;
  name: string;
  onClick(): void;
  icon?: string | null;
  subtitle?: string;
}

export const PromoIntro = ({ name, dueDate, onClick, subtitle, icon }: IPromoItemProps) => {
  return (
    <div className={styles['promo']} onClick={onClick} data-testid="PromoIntro">
      {icon && (
        <div className={styles['icon']}>
          <img alt={name} width="56" height="56" src={icon} className={styles['image']} />
        </div>
      )}
      <div className={styles['description']}>
        <ArticleHeading3 color="current_color">{name}</ArticleHeading3>
        {(subtitle || dueDate) && (
          <ArticleParagraph2 color="gray60_100">
            {subtitle && <span className={styles['subtitle']}>{subtitle}</span>}
            {dueDate && <span className={styles['subtitle']}>{dueDate}</span>}
          </ArticleParagraph2>
        )}
      </div>
    </div>
  );
};
